import Instense from "./Axios-config";
import { IGlobalSettingsRequest } from './../Contracts/IGlobalSettings';
import { IRoomTypeNew } from './../Contracts/IRoomType';
import { IConferenceRoomRequest } from "../Contracts/IConferenceRoomRequest";
import { IRoom, ISaveRoom } from "../Contracts/IRoom";
import { ISaveHotelKeySetupRequest } from "../Contracts/ISaveHotelKeySetupRequest";
import { IAddAssetType, IAddCommonAreaSubType, IAddLocationType } from "../Contracts/IFacilities";

export class EntityManagementService {

  public static GetHotelModules = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantId = tenantID;
    request.HotelId = HotelId;
    const url = `/EntityManagement/GetHotelModules`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      // debugger
      let result = response.data?.result as any;
      return result;
    });
  };

  public static GetAllModules = async (): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    const url = `/EntityManagement/GetAllModules`;
    return Instense.get(url, { params: null }).then((response) => {
      // console.log(response);
      let result = response.data.result as any;
      return result;
    });
  };

  public static UpdateHotelDefaultSetting = async (
    AllowPerformanceReview: number,
    AllowTimeOffReview: number,
    AllowDDReview: number,
    AllowBreakAttestation: number,
    showLocalTaxFields: number,
    HotelId: number,
    ClientID: string,
    // APIKey: string,
    // APISecret: string,
    DivisionCode: string
  ): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantId = tenantID;
    request.HotelId = HotelId;
    request.AllowPerformanceReview = AllowPerformanceReview;
    request.AllowTimeOffReview = AllowTimeOffReview;
    request.AllowBreakAttestation = AllowBreakAttestation;
    request.AllowDDReview = AllowDDReview;
    request.showLocalTaxFields = showLocalTaxFields;
    request.AllowBreakAttestation = AllowBreakAttestation;
    request.ClientId = ClientID;
    // request.APIKey = APIKey;
    // request.APISecret = APISecret;
    request.DivisionCode = DivisionCode;
    const url = `/EntityManagement/UpdateHotelDefaultSetting`;
    return Instense.get(url, { params: request }).then((response) => {

      let result = response.data as any;
      return result;
    });
  };

  public static UpdateHotelGlobalSetting = async (request: IGlobalSettingsRequest
  ): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.tenantID = tenantID;
    const url = `/EntityManagement/UpdateHotelGlobalSetting`;
    return Instense.post(url, request).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static GetAllRooms = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantId = tenantID;
    request.Hid = HotelId;
    const url = `/EntityManagement/GetAllRooms`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response.data?.result as any;
      return result;
    });
  };

  public static GetConferenceRooms = async (
    hotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantId = tenantID;
    request.Hid = hotelId;
    const url = `/EntityManagement/GetConferenceRooms`;
    return Instense.post(url, null, { params: request }).then((response) => {
      // console.log(response);
      let result = response.data?.result as any;
      return result;
    });
  };

  public static SaveConferenceRoom = async (
    request: IConferenceRoomRequest
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.tenantID = tenantID;
    const url = `/EntityManagement/SaveConferenceRoom`;
    return Instense.post(url, request).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static ValidateRoomType = async (
    request: any[], DeleteRoomIds, Hid
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request = request.map((item: IRoomTypeNew) => {
      item.tenantId = tenantID;
      return item;
    });
    const url = `/EntityManagement/ValidateRoomType`;

    const data = {
      RoomTypeNew: request,
      DeleteRoomIds: DeleteRoomIds,
      TenantID: tenantID,
      Hid: Hid
    }
    return Instense.post(url, data).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static ValidateRoom = async (
    request: ISaveRoom
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.TenantID = tenantID;
    const url = `/EntityManagement/ValidateRoomName`;


    return Instense.post(url, request).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };



  public static GetPayrollImportAccount = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantID = tenantID;
    request.Hid = HotelId;
    const url = `/EntityManagement/GetPayrollImportAccount`;
    return Instense.post(url, null, { params: request }).then((response) => {
      let result = response.data as any
      return result;
    });
  };

  public static SavePayrollImport = async (
    data: any, hid
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.TenantID = tenantID;
    request.Hid = hid;
    request.OprID = data.OperatingID;
    request.PayOprID = data.PayOprId;
    request.AutoTransfer = data.AutoTransfer;
    const url = `/EntityManagement/SavePayrollImport`;
    return Instense.post(url, null, { params: request }).then((response) => {
      let result = response.data as any
      return result;
    });
  };


  public static GetRoomType = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.tenantId = tenantID;
    request.hotelId = HotelId;
    const url = `/EntityManagement/GetRoomType`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response.data?.result as any;
      return result;
    });
  };
  public static SaveRoomTypeOld = async (request: IRoomTypeNew[]
  ): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request = request.map((item: IRoomTypeNew) => {
      item.tenantId = tenantID;
      return item;
    });
    const url = `/EntityManagement/SaveRoomType`;
    return Instense.post(url, request).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static SaveRoomType = async (request: IRoomTypeNew[], DeleteRoomIds, Hid, AccountingDate, PrevAccountingDate, roomList
  ): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request = request.map((item: IRoomTypeNew) => {
      item.tenantId = tenantID;
      item.accountingDate = AccountingDate ? AccountingDate : PrevAccountingDate;
      item.roomList = roomList.filter(x => x.RoomID === 0 || (typeof x.RoomID === 'number' && x.RoomID !== 0)).filter(x => x.RoomTypeId == item.PrevRoomTypeId).map(x => ({ ...x, TenantID: tenantID }))
      return item;
    });
    const url = `/EntityManagement/SaveRoomType`;

    const data = {
      RoomTypeNew: request,
      DeleteRoomIds: DeleteRoomIds,
      TenantID: tenantID,
      Hid: Hid,
      AccountingDate: AccountingDate ? AccountingDate : PrevAccountingDate,
      PrevAccountingDate: PrevAccountingDate ? PrevAccountingDate : AccountingDate,

    }


    return Instense.post(url, data).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static SaveBulkRoom = async (request: ISaveRoom[]): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request = request.map((item: ISaveRoom) => {
      item.TenantID = tenantID;
      return item;
    });
    const url = `/EntityManagement/SaveBulkRoom`;


    return Instense.post(url, request).then((response) => {
      // console.log(response);
      let result = response.data as any;
      return result;
    });
  };

  public static DeleteRoomType = async (uniqueno: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    var request: any = {};
    request.uniqueno = uniqueno;
    request.tenantID = tenantID;
    const url = `/EntityManagement/DeleteRoomType`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static DeleteConferenceRooms = async (roomID: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    var request: any = {};
    request.roomID = roomID;
    request.tenantID = tenantID;
    const url = `/EntityManagement/DeleteConferenceRooms`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static GetHotelGroupMapping = async (): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    var request: any = {};
    request.tenantId = tenantID;
    const url = `/EntityManagement/GetHotelGroupMapping`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };


  public static AddHotelCategory = async (category: string, uniqueno: number = 0): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    var request: any = {};
    request.category = category;
    request.uniqueno = uniqueno;
    request.tenantId = tenantID;
    const url = `/EntityManagement/AddHotelCategory`;
    return Instense.post(url, null, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static SaveGroupWithHotel = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    request.TenantId = tenantID;
    const url = `/EntityManagement/SaveGroupWithHotel`;
    return Instense.post(url, request).then((response) => {
      let result = response.data as any;
      return result;
    });

  };

  public static SaveCategoriesGroupWithHotel = async (requests: any[]): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    requests = requests?.map(request => {
      request.TenantId = tenantID;
      return request;
    });

    const url = `/EntityManagement/SaveCategoriesGroupWithHotel`;
    return Instense.post(url, requests).then((response) => {
      let result = response.data as any;
      return result;
    });

  };



  public static DeleteHotelCategory = async (uniqueno: number = 0): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    const request: any = {};
    request.Uniqueno = uniqueno;
    request.tenantId = tenantID;
    const url = `/EntityManagement/DeleteHotelCategory`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static DeleteHotelCategoryGroup = async (id: number = 0): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    const request: any = {};
    request.id = id;
    request.tenantId = tenantID;
    const url = `/EntityManagement/DeleteHotelCategoryGroup`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };
  public static DeleteGroupHotel = async (id: number = 0, hid: number = 0): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    const request: any = {};
    request.id = id;
    request.hid = hid;
    request.tenantId = tenantID;
    const url = `/EntityManagement/DeleteGroupHotel`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data as any;
      return result;
    });
  };





  public static GetHotelkeyAPISetup = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.Tenantid = tenantID;
    request.Hid = HotelId;
    const url = `/EntityManagement/GetHotelkeyAPISetup`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };

  public static GetHotelAPI = async (
    HotelId: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.Tenantid = tenantID;
    request.Hid = HotelId;
    const url = `/EntityManagement/GetHotelAPI`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };

  public static SaveHotelkeyAPISetup = async (request: ISaveHotelKeySetupRequest): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    request.tenantid = tenantID;
    const url = `/EntityManagement/SaveHotelkeyAPISetup`;
    return Instense.post(url, request).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

  public static GetCloudbedsApiKey = async (
    cloudbedsApiKey: string
  ): Promise<any[] | null> => {
    let request = {} as any;
    request.APIKey = cloudbedsApiKey;
    const url = `/EntityManagement/GetCloudbedsApiKey`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };

  public static GetGuestRoomDetails = async (
    date: string, hotelID: string
  ): Promise<any[] | null> => {

    let request = {} as any;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    request.hotelID = Number(hotelID);
    request.tenantID = tenantID;
    request.Date = date;
    const url = `/EntityManagement/GetGuestRoomDetails`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };







  public static GetFacilityType = async (
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.tenantid = tenantID;
    const url = `/EntityManagement/Get_FacilityType`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response as any;
      return result;
    });
  };

  public static GetGuestRoomSubType = async (
    date: string, hotelID: string
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.Hid = Number(hotelID);
    request.TenantId = tenantID;
    request.Date = date;
    const url = `/EntityManagement/LocationSubTypeList`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response as any;
      return result;
    });
  };
  public static SaveGuestLocationDetails = async (
    request: any
  ): Promise<any | null> => {
    const url = `/EntityManagement/SaveGuestLocationDetails`;
    const response = await Instense.post(url, request);
    let result = response.data as any;
    return result.result;
  };

  public static SaveBulkGuestSubTypeDetails = async (
    request: any
  ): Promise<any | null> => {
    const url = `/EntityManagement/SaveBulkGuestSubTypeDetails`;
    const response = await Instense.post(url, request);
    let result = response.data as any;
    return result.result;
  };

  public static GetCommonAreaRoomSubType = async (
    hid: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.Hid = hid;
    request.TenantID = tenantID;
    //request.Date = date;
    const url = `/EntityManagement/FacilityLocationSubTypesMasterList`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response as any;
      return result;
    });
  };

  public static SaveCALocationDetails = async (
    request: any
  ): Promise<any | null> => {
    const url = `/EntityManagement/SaveCALocationDetails`;
    const response = await Instense.post(url, request);
    let result = response.data as any;
    return result.result;
  };

  public static GetCommonAreaDetails = async (
    hotelID: string
  ): Promise<any[] | null> => {
    debugger;
    let request = {} as any;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    request.hotelID = Number(hotelID);
    request.tenantID = tenantID;
    const url = `/EntityManagement/GetCommonAreaDetails`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };


  public static GetAccDateGuestRoomDetails = async (
    hotelID: string
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.hid = Number(hotelID);
    request.tenantid = tenantID;
    request.createdby = 0;
    const url = `/EntityManagement/GetAccDateGuestRoomDetails`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      let result = response as any;
      return result;
    });
  };

  public static SaveCABulkStatusDetails = async (
    request: any
  ): Promise<any | null> => {
    const url = `/EntityManagement/SaveCABulkStatusDetails`;
    const response = await Instense.post(url, request);
    let result = response.data as any;
    return result.result;
  };

  public static locationExcelImport = async (
    files: any[], hotelID: string
  ): Promise<any | null> => {
    const url = `/EntityManagement/locationExcelImport`;
    let request = {} as any;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID: any = storage === null ? 0 : (storage.tenantID);
    request.TenantID = tenantID;
    request.hotelID = Number(hotelID);
    const formData: FormData = new FormData();
    files.forEach((element) => {
      formData.append("file", element);
    });
    formData.append("TenantID", JSON.stringify(request.TenantID));
    formData.append("hotelID", JSON.stringify(request.hotelID));
    return Instense.post(url, formData).then((response) => {
      let result: any = response.data;
      return result;
    });
  };

  public static DownloadLocationTemplete = async (
    hotelID: string
  ): Promise<any | null> => {

    let request = {} as any;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID as any;
    request.hotelID = Number(hotelID);
    request.tenantID = tenantID;
    const url = `/EntityManagement/DownloadLocationTemplete`;
    const response = await Instense.post(url, request, { responseType: "blob" });
    let result = response as any;
    return result;
  };

  public static SaveLocationImportTemplate = async (
    request: any
  ): Promise<any | null> => {
    const url = `/EntityManagement/SaveLocationImportTemplate`;
    const response = await Instense.post(url, request);
    let result = response.data as any;
    return result.result;
  };

  public static AddLocationSubType = async (
    request: IAddCommonAreaSubType
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.Tenantid = tenantID;
    const url = `/EntityManagement/AddLocationSubType`;
    return Instense.post(url, request).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static AddAssetType = async (
    request: IAddAssetType
  ): Promise<any[] | null> => {
    const url = `/Assets/AddAsset?assetName=${request.assetTypeName}`;
    return Instense.post(url).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static CheckFacilityMaintenanceSubscription = async (
    hid: number
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.tenantId = tenantID;
    request.hid = hid;
    const url = `/EntityManagement/CheckFacilityMaintenanceSubscription`;
    return Instense.get(url, { params: request }).then((response) => {
      // console.log(response);
      // debugger
      let result = response.data?.result as any;
      return result;
    });
  };

  public static UpdateLocationSubType = async (
    request: IAddCommonAreaSubType
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.Tenantid = tenantID;
    const url = `/EntityManagement/UpdateLocationSubType`;
    return Instense.post(url, request).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static DeleteLocationSubType = async (subTypeID): Promise<any | null> => {
    const url = `/EntityManagement/DeleteLocationSubType`;
    return Instense.delete(url, { params: { subTypeID } }).then((response) => {
      let result = response?.data?.result as any;
      return result;
    });
  };

  public static AddLocationType = async (
    request: IAddLocationType
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.Tenantid = tenantID;
    const url = `/EntityManagement/AddLocationType`;
    return Instense.post(url, request).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static UpdateLocationType = async (
    request: IAddLocationType
  ): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    request.Tenantid = tenantID;
    const url = `/EntityManagement/UpdateLocationType`;
    return Instense.post(url, request).then((response) => {
      let result = response.data as any;
      return result;
    });
  };

  public static DeleteLocationType = async (typeID): Promise<any | null> => {
    const url = `/EntityManagement/DeleteLocationType`;
    return Instense.delete(url, { params: { typeID } }).then((response) => {
      let result = response?.data?.result as any;
      return result;
    });
  };

  public static GetEndPointMaster = async (): Promise<any[] | null> => {
    const url = `/EntityManagement/GetEndPointMaster`;
    return Instense.get(url).then((response) => {
      let result = response.data?.result as any;
      return result;
    });
  };

}
